/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Spinner,
  Alert,
} from 'react-bootstrap';
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaToggleOn,
  FaToggleOff,
  FaTestTube,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../../services/axios';

function ApiWhatsappList() {
  const navigate = useNavigate();
  const [apis, setApis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [apiToDelete, setApiToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    loadApis();
  }, []);

  const loadApis = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/whatsappproviders');
      setApis(response.data);
    } catch (err) {
      console.error('Erro ao carregar APIs:', err);
      toast.error('Erro ao carregar lista de APIs WhatsApp');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!apiToDelete) return;

    try {
      setDeleting(true);
      await axios.delete(`/whatsappproviders/${apiToDelete.id}`);
      toast.success('API WhatsApp excluída com sucesso!');
      setShowDeleteModal(false);
      setApiToDelete(null);
      loadApis();
    } catch (err) {
      console.error('Erro ao excluir API:', err);
      toast.error('Erro ao excluir API WhatsApp');
    } finally {
      setDeleting(false);
    }
  };

  const toggleStatus = async (api) => {
    try {
      await axios.put(`/whatsappproviders/${api.id}`, {
        ...api,
        ativo: !api.ativo,
      });
      toast.success(
        `API ${!api.ativo ? 'ativada' : 'desativada'} com sucesso!`
      );
      loadApis();
    } catch (err) {
      console.error('Erro ao alterar status da API:', err);
      toast.error('Erro ao alterar status da API');
    }
  };

  const openDeleteModal = (api) => {
    setApiToDelete(api);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setApiToDelete(null);
  };

  const formatUrl = (url) => {
    if (!url) return '-';
    return url.length > 50 ? `${url.substring(0, 50)}...` : url;
  };

  const formatBody = (body, bodyType) => {
    if (!body) return '-';

    try {
      if (bodyType === 'raw') {
        const parsed = typeof body === 'string' ? JSON.parse(body) : body;
        const keys = Object.keys(parsed);
        return keys.length > 3
          ? `${keys.slice(0, 3).join(', ')}...`
          : keys.join(', ');
      }
      const parsed = typeof body === 'string' ? JSON.parse(body) : body;
      if (Array.isArray(parsed)) {
        const keys = parsed.map((item) => item.key).filter((key) => key);
        return keys.length > 3
          ? `${keys.slice(0, 3).join(', ')}...`
          : keys.join(', ');
      }
    } catch (e) {
      return 'Formato inválido';
    }

    return '-';
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
        <p className="mt-2">Carregando APIs WhatsApp...</p>
      </Container>
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>APIs WhatsApp</h2>
            <Button
              variant="primary"
              onClick={() => navigate('/whatsappproviders/new')}
            >
              <FaPlus className="me-2" />
              Nova API
            </Button>
          </div>

          {apis.length === 0 ? (
            <Alert variant="info" className="text-center">
              <h5>Nenhuma API WhatsApp cadastrada</h5>
              <p>
                Clique em "Nova API" para cadastrar sua primeira configuração de
                API WhatsApp.
              </p>
            </Alert>
          ) : (
            <div className="table-responsive">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>URL</th>
                    <th>Método</th>
                    <th>Tipo Body</th>
                    <th>Campos Body</th>
                    <th>Status</th>
                    <th>Criado em</th>
                    <th width="150">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {apis.map((api) => (
                    <tr key={api.id}>
                      <td>{api.id}</td>
                      <td title={api.url}>{formatUrl(api.url)}</td>
                      <td>
                        <span
                          className={`badge bg-${api.method === 'POST' ? 'success' : api.method === 'GET' ? 'primary' : 'warning'}`}
                        >
                          {api.method}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge bg-${api.bodyType === 'raw' ? 'info' : 'secondary'}`}
                        >
                          {api.bodyType === 'raw' ? 'JSON' : 'Form'}
                        </span>
                      </td>
                      <td title={JSON.stringify(api.body, null, 2)}>
                        {formatBody(api.body, api.bodyType)}
                      </td>
                      <td>
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => toggleStatus(api)}
                          title={
                            api.ativo
                              ? 'Clique para desativar'
                              : 'Clique para ativar'
                          }
                        >
                          {api.ativo ? (
                            <FaToggleOn className="text-success" size={20} />
                          ) : (
                            <FaToggleOff className="text-danger" size={20} />
                          )}
                        </Button>
                        <span
                          className={`ms-2 badge bg-${api.ativo ? 'success' : 'danger'}`}
                        >
                          {api.ativo ? 'Ativo' : 'Inativo'}
                        </span>
                      </td>
                      <td>
                        {new Date(api.createdAt).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </td>
                      <td>
                        <div className="d-flex gap-1">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() =>
                              navigate(`/whatsappproviders/${api.id}/edit`)
                            }
                            title="Editar"
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => openDeleteModal(api)}
                            title="Excluir"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>

      {/* Modal de Confirmação de Exclusão */}
      <Modal show={showDeleteModal} onHide={closeDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {apiToDelete && (
            <>
              <p>Tem certeza que deseja excluir esta API WhatsApp?</p>
              <div className="bg-light p-3 rounded">
                <strong>URL:</strong> {apiToDelete.url}
                <br />
                <strong>Método:</strong> {apiToDelete.method}
                <br />
                <strong>Status:</strong>{' '}
                {apiToDelete.ativo ? 'Ativo' : 'Inativo'}
              </div>
              <div className="mt-3">
                <small className="text-danger">
                  <strong>Atenção:</strong> Esta ação não pode ser desfeita.
                </small>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeDeleteModal}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={deleting}>
            {deleting ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Excluindo...
              </>
            ) : (
              'Excluir'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ApiWhatsappList;
